import DragAndDropUploadData from './View/Drag And Drop Upload Data.view';
export default DragAndDropUploadData;
